<div class="mb-4">
    <button class="btn btn-success" (click)="clickedNew()">{{ 'supplier-list.label.new' | translate}}</button>
</div>

<table class="table table-striped" *ngIf="suppliers">
    <thead>
        <tr>
            <td>{{'supplier-list.label.code' | translate}}</td>
            <td>{{'supplier-list.label.designation' | translate}}</td>
            <td>{{'supplier-list.label.country' | translate}}</td>
            <td>{{'supplier-list.label.zip' | translate}}</td>
            <td>{{'supplier-list.label.city' | translate}}</td>
            <td>{{'supplier-list.label.active' | translate}}</td>
            <td>{{'supplier-list.label.own' | translate}}</td>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let supplier of suppliers" [routerLink]="['/products/suppliers', supplier.id]">
            <td id="supplier-code">{{supplier.code}}</td>
            <td>{{supplier.desc}}</td>
            <td>{{supplier.person.country}}</td>
            <td>{{supplier.person.zip}}</td>
            <td>{{supplier.person.city}}</td>
            <td *ngIf="supplier.active">{{'supplier-list.label.active-yes' | translate}}</td>
            <td *ngIf="!supplier.active">{{'supplier-list.label.active-no' | translate}}</td>
            <td *ngIf="supplier.own">{{'supplier-list.label.active-yes' | translate}}</td>
            <td *ngIf="!supplier.own">{{'supplier-list.label.active-no' | translate}}</td>
        </tr>
    </tbody>
</table>


// WEBPACK FOOTER //
// ./src/app/product/supplier-list/supplier-list.component.html